import { TextField, TextFieldProps } from "@mui/material";
import { FieldHookConfig, useField } from "formik";

type TextInputProps = TextFieldProps & FieldHookConfig<string>;

const TextInput = ({ label, ...props }: TextInputProps) => {
  const [field, meta] = useField(props);
  const errorText = meta.error && meta.touched ? meta.error : "";

  return (
    <TextField
      {...field}
      {...props}
      label={label}
      error={!!errorText}
      helperText={errorText}
      fullWidth
      margin="normal"
    />
  );
};

export default TextInput;
